import React from 'react';

function Navbar() {
  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <nav className="bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20 items-center">
          <div className="flex-shrink-0">
            <h1 className="text-2xl font-serif text-primary-700">TrustBuilder</h1>
          </div>
          <div className="hidden md:block">
            <div className="ml-10 flex items-center space-x-8">
              <a
                href="#benefits-section"
                onClick={(e) => scrollToSection(e, 'benefits-section')}
                className="text-secondary-500 hover:text-primary-600 transition-colors duration-200 font-medium"
              >
                Features
              </a>
              <a
                href="#pricing-section"
                onClick={(e) => scrollToSection(e, 'pricing-section')}
                className="text-secondary-500 hover:text-primary-600 transition-colors duration-200 font-medium"
              >
                View Plans
              </a>
              <a 
                href="https://app.trustbuilder.law" 
                className="inline-flex items-center justify-center px-4 py-2 rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 transition-colors duration-200"
              >
                Get Started
              </a>
              <a 
                href="https://app.trustbuilder.law" 
                className="inline-flex items-center justify-center px-4 py-2 border border-primary-600 rounded-md shadow-sm text-sm font-medium text-primary-600 bg-white hover:bg-gray-50 transition-colors duration-200"
              >
                Sign In
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar; 